/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
    align: PropTypes.oneOf(['left', 'right']),
    column: PropTypes.bool,
    hcenter: PropTypes.bool,
    noCol: PropTypes.bool,
    noWrap: PropTypes.bool,
    spaceBetween: PropTypes.bool,
    vbottom: PropTypes.bool,
    vcenter: PropTypes.bool,
};

const defaultProps = {
    ...commonDefaultProps,
    align: 'left',
    column: false,
    hcenter: false,
    noCol: false,
    noWrap: false,
    spaceBetween: false,
    vbottom: false,
    vcenter: false,
};

const Row = (props) => {
    const classNames = [
        'c-grid__row',
        props.align === 'right' ? 'c-grid__row--align-right' : '',
        props.column ? 'c-grid__row--column' : '',
        props.hcenter ? 'c-grid__row--align-hcenter' : '',
        props.noCol ? 'c-grid__row--no-col' : '',
        props.noWrap ? 'c-grid__row--no-wrap' : '',
        props.spaceBetween ? 'c-grid__row--space-between' : '',
        props.vbottom ? 'c-grid__row--align-vbottom' : '',
        props.vcenter ? 'c-grid__row--align-vcenter' : '',
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];
    return (
        <props.componentClass
            className={concatClassNames(classNames)}
            {...filterProps(propTypes, props)}
        >
            {props.children}
        </props.componentClass>
    );
};

Row.propTypes = propTypes;

Row.defaultProps = defaultProps;

export default Row;
